module.exports = __webpack_public_path__ + "static/media/HCMM659.c4c425f9.jpg";